import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"


export const isLoadingUserSettingSitesData = signal(true)
export const isLoadingUserSettingProvidersData = signal(true)
export const userSettingSitesData = signal([])
export const userSettingProvidersData = signal([])
export const userSettingSitesFormData = signal({})
export const userSettingProvidersFormData = signal({})

// Computed
export const isLoadingUserSettingsSitesProvidersData = computed(() => isLoadingUserSettingProvidersData.value || isLoadingUserSettingSitesData.value)
export const isOpenUserSettingsSitesDrawer = computed(() => !isEmpty(userSettingSitesFormData.value))
export const isOpenUserSettingsProvidersDrawer = computed(() => !isEmpty(userSettingProvidersFormData.value))
export const isEditUserSettingsSitesDrawer = computed(() => userSettingSitesFormData.value?.id !== null)
export const isEditUserSettingsProvidersDrawer = computed(() => userSettingProvidersFormData.value?.id !== null)

// Functions
export const clearUserSettingSitesProviderSignals = () => batch(() => {
	isLoadingUserSettingSitesData.value = true
	isLoadingUserSettingProvidersData.value = true
	userSettingSitesData.value = []
	userSettingProvidersData.value = []
	userSettingSitesFormData.value = {}
	userSettingProvidersFormData.value = {}
})